export const FeatureTokenType = {
	DISABLE_PREROLL: 'disable_preroll',
	DISABLE_OVERLAY: 'disable_overlay',
};

export const FeatureTokenQueryParam = {
	[FeatureTokenType.DISABLE_PREROLL]: 'dp',
	[FeatureTokenType.DISABLE_OVERLAY]: 'do',
};
